import { styled } from '@mui/system';
import { Box, Typography, Paper, Stack } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import {
  SectionHeading as BaseSectionHeading,
  SectionSubtext as BaseSectionSubtext,
} from '../../../../../ui/typography';

export const PhilosophySectionWrapper = styled(Box)(({ theme }) => ({}));

export const SectionHeading = styled(BaseSectionHeading)(({ theme }) => ({
  fontFamily: fontFamilies?.gotham,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: '-1.2px',
  textAlign: 'center',
}));

export const SectionSubtext = styled(BaseSectionSubtext)(({ theme, customStyles }) => ({
  fontFamily: fontFamilies?.quicksand,
  fontWeight: 400,
  fontSize: '22px',
  lineHeight: '32px',
  textAlign: 'center',
  maxWidth: '900px',
  ...customStyles,
  margin: '14px auto 50px',
  whiteSpace: 'pre-line',
}));

export const PhilosophyText = styled(SectionSubtext)(({ theme }) => ({
  textAlign: 'left',
  margin: '0 auto 0 0',
}));

export const PhilosophyCaptionText = styled(SectionSubtext)(({ theme }) => ({
  margin: '48px auto 0',
}));

export const PhilosophyContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(4),
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '1fr 1fr',
    gap: '50px',
    maxWidth: '1100px',
    margin: '0 auto',
  },
}));

export const PhilosophyLeftColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  order: 2,
  [theme.breakpoints.up('md')]: {
    order: 1,
    justifyContent: 'center',
  },
}));

export const PhilosophyTextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '30px',
  alignItems: 'flex-start',
}));

export const PhilosophyImagePaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: 3,
  display: 'inline-block',
  backgroundColor: 'common.white',
  border: '1px solid',
  borderColor: 'rgba(0,0,0,0.08)',
  maxWidth: '100%',
}));

export const PhilosophyImage = styled('img')(({ theme }) => ({
  display: 'block',
  width: '100%',
  maxWidth: '565px',
  height: '550px',
  objectFit: 'cover',
  borderRadius: '30px',
  border: '10px solid',
  borderColor: colors.whiteText,
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
  [theme.breakpoints.down('md')]: {
    justifySelf: 'center',
  },
}));

export const PhilosophyRightColumn = styled(Box)(({ theme }) => ({
  order: 1,
  [theme.breakpoints.up('md')]: {
    order: 2,
  },
}));

export const PhilosophyTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.heading,
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
  },
}));

export const PhilosophySubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
  },
}));

export const PhilosophyPillsContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.25),
}));

export const PhilosophyButtonContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
  },
}));
